const recommendationData = [
    {
        id: "safJh_jIuL0",
        name: "Michael Richardson",
        description: "Recruiter Orange",
        profile_image: {
            small: "https://images.unsplash.com/profile-1635681699255-b553544c18b8image?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&cs=tinysrgb&fit=crop&h=32&w=32",
            medium: "https://images.unsplash.com/profile-1635681699255-b553544c18b8image?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&cs=tinysrgb&fit=crop&h=64&w=64",
            large: "https://images.unsplash.com/profile-1635681699255-b553544c18b8image?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&cs=tinysrgb&fit=crop&h=128&w=128",
        },
    },
    {
        id: "aPl3ti9M4w4",
        name: "Camila Seves",
        description: "Data Analyst",
        profile_image: {
            small: "https://images.unsplash.com/profile-1643323230500-15b5907076c2image?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&cs=tinysrgb&fit=crop&h=32&w=32",
            medium: "https://images.unsplash.com/profile-1643323230500-15b5907076c2image?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&cs=tinysrgb&fit=crop&h=64&w=64",
            large: "https://images.unsplash.com/profile-1643323230500-15b5907076c2image?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&cs=tinysrgb&fit=crop&h=128&w=128",
        },
    },

    {
        id: "NS9FujfPw5A",
        name: "Ilya Bronskiy",
        description: "UI/UX Designer",
        profile_image: {
            small: "https://images.unsplash.com/profile-1639074621611-14ea292eb437?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&cs=tinysrgb&fit=crop&h=32&w=32",
            medium: "https://images.unsplash.com/profile-1639074621611-14ea292eb437?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&cs=tinysrgb&fit=crop&h=64&w=64",
            large: "https://images.unsplash.com/profile-1639074621611-14ea292eb437?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&cs=tinysrgb&fit=crop&h=128&w=128",
        },
    },
    {
        id: "N4NQrNsllDs",
        name: "Jasmin Chew",
        description: "SEO Specialist",
        profile_image: {
            small: "https://images.unsplash.com/profile-1629930000752-cf2b8a41d392image?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&cs=tinysrgb&fit=crop&h=32&w=32",
            medium: "https://images.unsplash.com/profile-1629930000752-cf2b8a41d392image?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&cs=tinysrgb&fit=crop&h=64&w=64",
            large: "https://images.unsplash.com/profile-1629930000752-cf2b8a41d392image?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&cs=tinysrgb&fit=crop&h=128&w=128",
        },
    },
];

export default recommendationData;
